import { render, staticRenderFns } from "./sendFeedback.vue?vue&type=template&id=af231998&scoped=true"
import script from "./sendFeedback.vue?vue&type=script&lang=js"
export * from "./sendFeedback.vue?vue&type=script&lang=js"
import style0 from "./sendFeedback.vue?vue&type=style&index=0&id=af231998&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af231998",
  null
  
)

export default component.exports